import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CalendarService } from '../../services/calendar/calendar.service';
import { TrainingLevelActions, TrainingLevelApiActions } from './trainingLevel.actions';
import { catchError, map, of, switchMap } from 'rxjs';

@Injectable()
export class TrainingLevelEffects {
    constructor(
        private actions$: Actions,
        private calendarService: CalendarService
    ) {}

    loadTrainingLevels = createEffect(() => {
        return this.actions$.pipe(
            ofType(TrainingLevelApiActions.loadTrainingLevels),
            switchMap(() =>
                this.calendarService.loadTrainingLevels().pipe(
                    map((trainingLevels) => TrainingLevelActions.loadTrainingLevelSuccess({ trainingLevels })),
                    catchError((error) => of(TrainingLevelActions.loadTrainingLevelFailure({ error })))
                )
            )
        );
    });
}
